import React,{useEffect} from 'react'
import '../../styles/preisrechner.css'
import * as utils from './Helpers/SearchHelper'
import * as formUtils from './Helpers/FormHelper'
const InputForm = props => {

	const initializeDynamicComponent = () =>
	{
		let actual_JSON = props.actualJson;
		let chosenIndex = props.service;
		document.getElementsByClassName("vermHeading")[0].innerHTML = actual_JSON.Services[chosenIndex].name;
		document.getElementsByClassName("vermRightContent")[0].innerHTML = '<div class="vermHeading headRight">'+actual_JSON.Services[chosenIndex].name+'</div>';
		actual_JSON.Services[chosenIndex].sidebars[1].sidebar.forEach((elem,index) => {
      if (elem.title == "Beispieldaten"){
        document.getElementsByClassName("vermRightContent")[0].appendChild(utils.createLinkChapter(elem.title,elem.descriptions,index))
      } else {
        document.getElementsByClassName("vermRightContent")[0].appendChild(utils.createChapter(elem.title,elem.descriptions,index))
      }
		});
		document.querySelectorAll('.vermRightContent')[0].classList.add('show');


		document.querySelectorAll('.vermInputHorizontal')[0].innerHTML = "";
		actual_JSON.Services[chosenIndex].preisrechner.forEach((item,index) => {
			if (item.viewtype == 1 || item.viewtype == 5 || item.viewtype == 6){
				document.querySelectorAll('.vermInputHorizontal')[0].appendChild(formUtils.createTextBox(props.setDataFromId,item.title,item.type,item.viewtype,false));
			}
			if (item.viewtype == 2){
				document.querySelectorAll('.vermInputHorizontal')[0].appendChild(formUtils.createDatePicker(props.setData,item.title,item.type,item.viewtype,false));
			}
			if (item.viewtype == 3){
				document.querySelectorAll('.vermInputHorizontal')[0].appendChild(formUtils.createRadioButtons(props.setData,item.title,item.values,item.type,index,item.viewtype));
			}
			if (item.viewtype == 4){
				document.querySelectorAll('.vermInputHorizontal')[0].appendChild(formUtils.createBooleanRadioButtons(props.setData,item.title,item.type,index,item.viewtype));
			}
      if (item.viewtype == 10){
        document.querySelectorAll('.vermInputHorizontal')[0].appendChild(formUtils.createGeoBox(props.setDataFromId,item.title,item.type,item.viewtype,false));
      }
		});

    if (props.storage() != null){
      console.log(props.storage());
      props.storage().forEach(x => 
        {
          let elem = document.getElementById(x.type.toString());
          let radioElem = document.getElementsByClassName(x.type.toString());
          console.log(radioElem);          
          if (elem != null) {elem.value = x.value;}
          if (radioElem.length != 0) {
            if (typeof x.value === "boolean")
              radioElem[(x.value == false) ? 1 : 0].checked = true;
            else
                radioElem[x.value].checked = true;
            }
          
      });
    }
	}

	useEffect(() => {
		initializeDynamicComponent();
	});

	return (
	<div className="step">
      <div className="vermFormContent">

        <div className="vermLeftContent"></div>
        <div className="vermCenterContent">
          <div className="vermHeading">
          </div>
          <div className="vermInputHorizontal">
            
          </div>
        </div>
        <div className="vermRightSide">
          <div className="vermRightContent">
            <div className="vermHeading headRight">
              Höhenaufnahme
            </div>
            <ul className="vernRightList">
              <p>Durch die wiederholende Messungen der gleichen Überwachugnspunkte werden allfällige
                Bewegungen festgehalten. Dieser Verschiebungen werden aufbereitet und in Plänte und
                Tabellen visualisiert.</p>
            </ul>

            <div className="vernDownload">
              <div className="rightdivider"></div>
              <p>Beispielsdaten <br /> herunterladen </p>
              <div className="downloadLinkGrp">
                <img width="12" src="./assets/arrow-down.svg"/>
                <a className="downloadLink" href="#">Höhenaufnahme.pdf</a>
              </div>
              <div>
                <img width="12" src="./assets/arrow-down.svg"/>
                <a className="downloadLink" href="#">Höhenaufnahme.dwg</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
	)
}

export default InputForm